import clone from 'lodash/clone';
import { initialData } from 'scenes/Form/components/FirmPortfolioCreateUpdateItemForm/initialData';
import { DateHelpers } from 'helpers/date-helpers';

export const Normalizer = {
  fetch: data => {
    return {
      ...initialData,
      fields: {
        ...initialData.fields,
        ...data.fields,
      },
      init: true,
    };
  },

  send: (values, isEditMode = false) => {
    const result = clone(values);
    Object.keys(result).forEach(f => {
      if (
        result[f] === null ||
        typeof result[f] === 'undefined' ||
        (isEditMode && ['AssignedFirmID', 'Type'].includes(f))
      ) {
        delete result[f];
      } else if ('AssignedFirmID' === f) {
        if (result[f].__isNew__) {
          result.AssignedFirmOther = result[f].value;
          result[f] = -2;
        } else {
          result[f] = result[f].value;
        }
      } else if ('Date' === f && result[f] instanceof Date) {
        result[f] = DateHelpers.jsDateToString(result[f], false);
      }
    });

    return result;
  },
};
